import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import NavBar from './components/navBar'
import { AuthProvider } from './context/authContext'
import { ExamProvider } from './context/examContext'
import { ThemeProvider } from './context/themeContext'
import { useAuth } from './hooks'
import AdminPage from './pages/adminPage'
import SuperAdminPage from './pages/superAdminPage'
import ExamPage from './pages/examPage'
import HistoryPage from './pages/historyPage'
import TrialAttemptsPage from './pages/trialAttemptsPage'
import ResultDetailPage from './pages/resultDetailPage'
import LoginPage from './pages/loginPage'
import RegisterPage from './pages/registerPage'
import ForgotPasswordPage from './pages/forgotPasswordPage'
import TermsPage from './pages/termsPage'
import PrivacyPage from './pages/privacyPage'
import ProfilePage from './pages/profilePage'
import UsageHistoryPage from './pages/usageHistoryPage'
import VoucherRedemptionsPage from './pages/voucherRedemptionsPage'
import GuidePage from './pages/guidePage'

function ProtectedLayout() {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return (
    <div className="min-h-screen flex flex-col" style={{ color: 'var(--text-1)' }}>
      <NavBar />
      <main className="flex-1 flex flex-col"><Outlet /></main>
    </div>
  )
}

// Public — no login required, since it explains how to register/log in in the
// first place. Still shows the navbar (works fine logged out; NavBar's own
// user-dependent bits are already guarded) so navigation stays consistent.
function GuideLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ color: 'var(--text-1)' }}>
      <NavBar />
      <main className="flex-1 flex flex-col"><GuidePage /></main>
    </div>
  )
}

function AdminRoute() {
  const { user } = useAuth()
  if (!user || user.role !== 'organisation') return <Navigate to="/" replace />
  return <AdminPage />
}

function SuperAdminRoute() {
  const { user } = useAuth()
  if (!user || user.role !== 'superadmin') return <Navigate to="/" replace />
  return <SuperAdminPage />
}

function SuperAdminVoucherRedemptionsRoute() {
  const { user } = useAuth()
  if (!user || user.role !== 'superadmin') return <Navigate to="/" replace />
  return <VoucherRedemptionsPage />
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login"           element={<LoginPage />} />
            <Route path="/register"        element={<RegisterPage />} />
            <Route path="/forgotPassword"  element={<ForgotPasswordPage />} />
            <Route path="/terms"           element={<TermsPage />} />
            <Route path="/privacy"         element={<PrivacyPage />} />
            <Route path="/guide"           element={<GuideLayout />} />
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<ExamProvider><ExamPage /></ExamProvider>} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/trial-attempts" element={<TrialAttemptsPage />} />
              <Route path="/result/:id" element={<ResultDetailPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/usage-history" element={<UsageHistoryPage />} />
              <Route path="/admin" element={<AdminRoute />} />
              <Route path="/superadmin" element={<SuperAdminRoute />} />
              <Route path="/superadmin/vouchers/:voucherId/redemptions" element={<SuperAdminVoucherRedemptionsRoute />} />
            </Route>
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}
